'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderField = exports.getDiscussionLabel = exports.getDiscussionId = exports.getReactionsField = exports.getSharesField = exports.getCommentsField = exports.getThumbsDownField = exports.getThumbsUpField = exports.getViews = exports.getText = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactCsv = require('react-csv');

var _map = require('lodash/fp/map');

var _map2 = _interopRequireDefault(_map);

var _uniq = require('lodash/fp/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _flow = require('lodash/fp/flow');

var _flow2 = _interopRequireDefault(_flow);

var _DayPickerInput = require('react-day-picker/DayPickerInput');

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

require('react-day-picker/lib/style.css');

var _moment3 = require('react-day-picker/moment');

var _basicReportSummary = require('./../basic-report-summary');

var _basicReportSummary2 = _interopRequireDefault(_basicReportSummary);

var _basicReportHeader = require('./../basic-report-header');

var _basicReportHeader2 = _interopRequireDefault(_basicReportHeader);

var _basicReportRow = require('./../basic-report-row');

var _basicReportRow2 = _interopRequireDefault(_basicReportRow);

var _basicReportTotalsRow = require('./../basic-report-totals-row');

var _basicReportTotalsRow2 = _interopRequireDefault(_basicReportTotalsRow);

var _reportHeader = require('./../report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _collaborationCard = require('./../../components/collaboration-card');

var _collaborationCard2 = _interopRequireDefault(_collaborationCard);

var _dyzioIcons = require('../../components/dyzio-icons');

var _utils = require('./utils');

var _csvGenerator = require('./csv-generator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';

var pinkBoldTextStyle = {
  fontWeight: 'bold',
  color: '#fc4085',
  fontSize: 14
};

var pinkIconStyle = {
  color: '#fc4085',
  marginLeft: 10
};

var shortOrder = function shortOrder() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'descending';

  if (text === 'descending' || text === 'desc') {
    return 'desc';
  }
  return 'asc';
};

var getHandle = function getHandle(post) {
  if (post.type === 'stories') {
    return post.attributes.username;
  }
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'YOUTUBE':
      return post.channelTitle;
    case 'TWITTER':
      return post.twitterHandle;
    case 'FACEBOOK':
      return post.facebookHandle || post.influencerName;
    case 'INSTAGRAM':
      return post.instagramHandle || post.influencerName;
    default:
      return null;
  }
};

var getText = exports.getText = function getText(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'YOUTUBE':
      return post.description;
    default:
      return post.text;
  }
};

var getViews = exports.getViews = function getViews(post) {
  if (post.type === 'stories') {
    return post.attributes.latestImpressions || 0;
  }
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'INSTAGRAM':
    case 'FACEBOOK':
      return post.latestStatistic.viewCount || 0;
    case 'YOUTUBE':
      var latest = _lodash2.default.last(post.statistics);
      return latest.viewCount || 0;
    case 'TIKTOK':
      var lastData = _lodash2.default.last(post.tiktokData || []);
      return lastData.playCount;
    default:
      return 0;
  }
};

var getThumbsUpField = exports.getThumbsUpField = function getThumbsUpField(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'TWITTER':
    case 'FACEBOOK':
    case 'INSTAGRAM':
      return post.latestStatistic.likeCount || 0;
    case 'YOUTUBE':
      var latest = _lodash2.default.last(post.statistics);
      return latest.likeCount || 0;
    default:
      return 0;
  }
};

var getThumbsDownField = exports.getThumbsDownField = function getThumbsDownField(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'YOUTUBE':
      var latest = _lodash2.default.last(post.statistics);
      return latest.dislikeCount || 0;
    default:
      return 0;
  }
};

var getCommentsField = exports.getCommentsField = function getCommentsField(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'FACEBOOK':
    case 'TWITTER':
    case 'INSTAGRAM':
      return post.latestStatistic.commentCount || 0;
    case 'YOUTUBE':
      var latest = _lodash2.default.last(post.statistics);
      return latest.commentCount || 0;
    default:
      return 0;
  }
};

var getSharesField = exports.getSharesField = function getSharesField(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'FACEBOOK':
      return post.latestStatistic.shareCount || 0;
    case 'TWITTER':
      return post.latestStatistic.retweetCount || 0;
    default:
      return 0;
  }
};

var getReactionsField = exports.getReactionsField = function getReactionsField(post) {
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'FACEBOOK':
      return post.latestStatistic.reactionCount || 0;
    default:
      return 0;
  }
};

var getDiscussionId = exports.getDiscussionId = function getDiscussionId(post) {
  //
  if (_lodash2.default.has(post, 'relationships.discussion.data.id')) {
    return _lodash2.default.get(post, 'relationships.discussion.data.id');
  }

  if (_lodash2.default.has(post, 'trackedAsset.discussionId')) {
    return _lodash2.default.get(post, 'trackedAsset.discussionId');
  }

  if (_lodash2.default.has(post, 'trackedAsset.discussion.id')) {
    return _lodash2.default.get(post, 'trackedAsset.discussion.id');
  }

  if (_lodash2.default.has(post, 'discussion.id')) {
    return _lodash2.default.get(post, 'discussion.id');
  }

  // Try to resolve discusssionId by matching handle and campaign discussions
  var handle = _lodash2.default.get(post, 'discussionName');
  if (handle) {
    var discussion = _lodash2.default.find(_lodash2.default.get(post, 'campaign.discussions', []), 'name', handle);
    return _lodash2.default.get(discussion, 'id');
  }
  return _lodash2.default.get(post, 'discussionName');
};

var getDiscussionLabel = exports.getDiscussionLabel = function getDiscussionLabel(post) {
  if (post.type === 'stories') {
    return _lodash2.default.get(post, 'attributes.username');
  }
  return _lodash2.default.get(post, 'trackedAsset.discussionName') || _lodash2.default.get(post, 'discussionName');
};

var getOrderField = exports.getOrderField = function getOrderField(post, field) {
  switch (field) {
    case 'platform':
      return _lodash2.default.get(post, 'trackedAsset.platform');
    case 'influencer':
      return getHandle(post);
    case 'title':
      return _lodash2.default.lowerCase(getText(post));
    case 'views':
      return getViews(post);
    case 'thumbsUp':
      return getThumbsUpField(post);
    case 'thumbsDown':
      return getThumbsDownField(post);
    case 'comments':
      return getCommentsField(post);
    case 'shares':
      return getSharesField(post);
    case 'reactions':
      return getReactionsField(post);
    default:
      return _lodash2.default.get(post, 'publishedDate');
  }
};

var tableStyle = {
  marginBottom: 0
};

var greenBoldTextStyle = {
  fontWeight: 'bold',
  color: '#20c49e',
  fontSize: 14
};

var greenIconStyle = {
  color: '#20c49e',
  marginLeft: 10
};

var inputStyle = {
  margin: 5
};

var BasicReport = function BasicReport(props) {
  var onFilterChange = props.onFilterChange,
      onOrderChanged = props.onOrderChanged,
      filter = props.filter,
      order = props.order,
      rightFilterOptions = props.rightFilterOptions,
      withHeader = props.withHeader,
      hasMarketingCampaigns = props.hasMarketingCampaigns,
      ads = props.ads,
      emptyCampaignText = props.emptyCampaignText,
      reportMode = props.reportMode,
      deleteCallback = props.deleteCallback,
      onDownloadClick = props.onDownloadClick,
      withDaysFilter = props.withDaysFilter,
      withDatePeriodFilter = props.withDatePeriodFilter,
      datePeriodFilterValues = props.datePeriodFilterValues,
      daysOptions = props.daysOptions,
      onPerDaysChanged = props.onPerDaysChanged,
      onDateFilterChange = props.onDateFilterChange,
      perDaysOption = props.perDaysOption,
      emptyCampaignMessageType = props.emptyCampaignMessageType,
      onForceRefresh = props.onForceRefresh,
      isLoadingMarketingCampaigns = props.isLoadingMarketingCampaigns,
      loadingMarketingCampaignsFailed = props.loadingMarketingCampaignsFailed,
      hasRightFilterOptions = props.hasRightFilterOptions,
      assetOptions = props.assetOptions,
      shouldRenderShareableLinks = props.shouldRenderShareableLinks,
      instagramHandleFilter = props.instagramHandleFilter;
  //

  var _ref = props.data || { data: { errored: true } },
      data = _ref.data,
      meta = _ref.meta;

  var name = data.name,
      country = data.country,
      liveDate = data.liveDate,
      endDate = data.endDate,
      createdBy = data.createdBy,
      posts = data.posts,
      stories = data.stories,
      tiktoks = data.tiktoks,
      telegrams = data.telegrams,
      newTypeAssets = data.newTypeAssets,
      hashtags = data.hashtags,
      campaignType = data.campaignType,
      influencer = data.influencer,
      influencers = data.influencers,
      errored = data.errored;


  var handleDownloadClick = onDownloadClick || _lodash2.default.noop();

  var vkSnapChatAndBlogs = _lodash2.default.flatten(_lodash2.default.values(newTypeAssets));

  var processed = _lodash2.default.compact(posts);
  var isACR = campaignType === 'ACR';

  var adsCount = ads ? _lodash2.default.size(ads) : null;
  var isEmptyCampaign = _lodash2.default.size(processed) + _lodash2.default.size(telegrams) + _lodash2.default.size(stories) + _lodash2.default.size(tiktoks) + _lodash2.default.size(vkSnapChatAndBlogs) === 0;

  var hostname = window.location.hostname;


  var compliantHostnames = ['share.dyzio.co', 'app.dyzio.co', 'reporting.abbottlyon.com'];
  var isDyzio = _lodash2.default.includes(compliantHostnames, hostname);

  var hasYoutube = _lodash2.default.some(processed, { trackedAsset: { platform: 'YOUTUBE' } });

  var postsAndStories = processed;

  if (stories && stories.length > 0) {
    _lodash2.default.forEach(stories, function (s) {
      s.publishedDate = s.attributes.publishedDate;
      var trackedAsset = _lodash2.default.clone(_lodash2.default.get(s, 'attributes'));
      s.trackedAsset = trackedAsset;
    });
    postsAndStories = _lodash2.default.concat(stories, processed);
  }

  var headerInfo = {
    hasLogo: false,
    campaignName: name,
    reportDate: liveDate,
    reportType: 'Campaign report',
    reportCountry: country,
    hashtags: hashtags,
    liveDate: liveDate,
    endDate: endDate
  };

  var basicData = null;
  var filename = void 0;
  var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');

  if (!_lodash2.default.isEmpty(vkSnapChatAndBlogs)) {
    var _postsAndStories;

    (_postsAndStories = postsAndStories).push.apply(_postsAndStories, (0, _toConsumableArray3.default)(vkSnapChatAndBlogs));
  }

  if (!_lodash2.default.isEmpty(tiktoks)) {
    var _postsAndStories2;

    var newTiktoks = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(tiktoks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var t = _step.value;

        var trackedAsset = _lodash2.default.clone(t);
        t.trackedAsset = trackedAsset;
        newTiktoks.push(t);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    console.log('newTiktoks', newTiktoks);
    console.log('tiktoks', tiktoks);

    (_postsAndStories2 = postsAndStories).push.apply(_postsAndStories2, (0, _toConsumableArray3.default)(_lodash2.default.flatten(newTiktoks)));
  }

  var channels = (0, _flow2.default)((0, _map2.default)('trackedAsset.platform'), _uniq2.default)(postsAndStories);

  if (!_lodash2.default.isEmpty(telegrams)) {
    var _postsAndStories3;

    var newTelegrams = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(telegrams), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _t = _step2.value;

        var _trackedAsset = _lodash2.default.clone(_t);
        _t.trackedAsset = _trackedAsset;
        newTelegrams.push(_t);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    console.log('newTellys', newTelegrams);

    (_postsAndStories3 = postsAndStories).push.apply(_postsAndStories3, (0, _toConsumableArray3.default)(_lodash2.default.flatten(newTelegrams)));
  }

  var discussionsNotUnique = _lodash2.default.map(postsAndStories, function (post) {
    if (post.attributes && post.attributes.username && post.attributes.username.match(/1000/)) {
      console.log(post);
    }

    return {
      label: getDiscussionLabel(post),
      value: getDiscussionId(post)
    };
  });

  var discussions = _lodash2.default.map(discussionsNotUnique, function (item) {
    if (!_lodash2.default.isNil(item.label) && !_lodash2.default.isNil(item.value)) {
      return item;
    }
    // Resolve discussionId
    var goodRecord = _lodash2.default.find(discussionsNotUnique, function (record) {
      return _lodash2.default.get(record, 'label') === _lodash2.default.get(item, 'label') && !_lodash2.default.isNil(record.value);
    });

    if (goodRecord) {
      return goodRecord;
    }
    return {
      label: _lodash2.default.get(item, 'label'),
      value: _lodash2.default.get(item, 'label')
    };
  });

  var uniqDiscussions = _lodash2.default.uniqBy(_lodash2.default.compact(discussions), 'value');
  var alphaSortedDiscussions = _lodash2.default.orderBy(uniqDiscussions, function (item) {
    return _lodash2.default.lowerCase(_lodash2.default.deburr(item.label));
  }, ['asc']);

  if (filter && filter.platform) {
    postsAndStories = _lodash2.default.filter(postsAndStories, ['trackedAsset.platform', filter.platform]);
  }

  if (filter && filter.discussion) {
    var lowerDiscussion = _lodash2.default.toLower(filter.discussion);
    postsAndStories = _lodash2.default.filter(postsAndStories, function (postOrStory) {
      var objectDiscussionName = _lodash2.default.toLower(_lodash2.default.get(postOrStory, 'discussionName', null));
      var matchesByDiscussionId = getDiscussionId(postOrStory) === _lodash2.default.get(filter, 'discussion');
      var matchesByStoryHandle = _lodash2.default.get(postOrStory, 'attributes.username', null) === instagramHandleFilter;
      var matchesByAssetDiscussionName = _lodash2.default.get(postOrStory, 'trackedAsset.discussionName', null) === instagramHandleFilter;
      var matchesByAssetDiscussionName2 = _lodash2.default.toLower(_lodash2.default.get(postOrStory, 'trackedAsset.discussionName', null)) === lowerDiscussion;
      var matchByAssetDiscName = matchesByAssetDiscussionName || matchesByAssetDiscussionName2;
      var matchesByObjectDiscussionName = objectDiscussionName === lowerDiscussion;
      return matchesByDiscussionId || matchByAssetDiscName || matchesByStoryHandle || matchesByObjectDiscussionName;
    });
  }

  // sorting haoppens here....
  if (order && order.field) {
    _lodash2.default.forEach(postsAndStories, function (p) {
      if (!p.orderBy) p.orderBy = {};
      p.orderBy[order.field] = getOrderField(p, order.field);
    });

    postsAndStories = _lodash2.default.orderBy(postsAndStories, ['orderBy.' + order.field], [shortOrder(order.value)]);
  }

  var dname = _lodash2.default.get(_lodash2.default.find(uniqDiscussions, ['value', filter.discussion]), 'label', instagramHandleFilter);
  var currentDiscussionName = filter.discussion && dname;

  var allPosts = postsAndStories;

  _lodash2.default.forEach(postsAndStories, function (asset) {
    if (_lodash2.default.get(asset, 'instagramAccountId') || _lodash2.default.get(asset, 'type') === 'stories') {
      var instagramId = _lodash2.default.get(asset, 'instagramAccountId', _lodash2.default.get(asset, 'attributes.instagramAccountId'));
      var matchedInfluencer = _lodash2.default.find(influencers, function (inf) {
        return inf.instagramId === instagramId;
      });
      _lodash2.default.assign(asset, {
        followerCount: _lodash2.default.get(matchedInfluencer, 'instagramCount')
      });
    } else {
      var discussionId = _lodash2.default.get(asset, 'trackedAsset.discussionId');

      var platform = _lodash2.default.toLower(_lodash2.default.get(asset, 'trackedAsset.platform'));
      var _matchedInfluencer = _lodash2.default.find(influencers, function (inf) {
        return inf.discussionId === discussionId;
      });
      _lodash2.default.assign(asset, {
        followerCount: _lodash2.default.get(_matchedInfluencer, platform + 'Count')
      });
    }
  });

  var YOUTUBE_AUDIT_LIVE = false;
  var showAggregates = !YOUTUBE_AUDIT_LIVE || !(isDyzio && hasYoutube);

  if (data) {
    filename = _lodash2.default.kebabCase(data.name) + '-' + timestamp + '.csv';
    basicData = (0, _csvGenerator.getCsvData)(postsAndStories);
  }

  var totalReach = (0, _utils.getTotalReach)(postsAndStories);
  var totalImpressions = (0, _utils.getTotalImpressions)(postsAndStories);

  var summaryTotals = {
    totalReach: totalReach,
    totalImpressions: totalImpressions
  };

  var orderedPostsAndStories = !order ? _lodash2.default.orderBy(allPosts, ['publishedDate'], ['desc']) : allPosts;

  var influencerCount = (0, _utils.getInfluencerCount)(orderedPostsAndStories);
  var assetCount = (0, _utils.getAssetCount)(orderedPostsAndStories);
  var totalViews = (0, _utils.getTotalViews)(orderedPostsAndStories);
  var totalLikes = (0, _utils.getTotalLikes)(orderedPostsAndStories);
  var totalShares = (0, _utils.getTotalShares)(orderedPostsAndStories);
  var totalComments = (0, _utils.getTotalComments)(orderedPostsAndStories);

  var totalEngagements = _lodash2.default.sum([totalLikes, totalShares, totalComments]);

  var campaignHasPosts = meta && meta.postCount + meta.storyCount > 0;
  var appearsToBeEmpty = orderedPostsAndStories.length === 0 && campaignHasPosts;
  return _react2.default.createElement(
    'div',
    null,
    withHeader && _react2.default.createElement(
      _semanticUiReact.Card,
      { fluid: true, color: 'pink' },
      _react2.default.createElement(
        _semanticUiReact.Card.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: true },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              name
            ),
            'created by ',
            createdBy
          )
        ),
        _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
      )
    ),
    showAggregates && _react2.default.createElement(_basicReportSummary2.default, {
      totalReach: summaryTotals.totalReach,
      totalImpressions: summaryTotals.totalImpressions,
      influencerCount: influencerCount,
      assetCount: assetCount,
      totalEngagements: totalEngagements,
      totalViews: totalViews
      // adsCount={adsCount}
    }),
    isACR && _react2.default.createElement(_collaborationCard2.default, influencer),
    showAggregates && _react2.default.createElement(
      _semanticUiReact.Menu,
      null,
      _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        null,
        _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          null,
          _react2.default.createElement(
            'strong',
            null,
            'FILTER BY:'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          { scrolling: true, item: true, text: _lodash2.default.lowerCase(filter.platform) || 'platform' },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            filter.platform && _react2.default.createElement(
              _semanticUiReact.Dropdown.Item,
              {
                onClick: onFilterChange,
                value: 'platform.reset'
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
              'reset'
            ),
            _lodash2.default.map(channels, function (channel) {
              return _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  value: 'platform.' + channel,
                  onClick: onFilterChange
                },
                _lodash2.default.toLower(channel) === 'tiktok' ? _react2.default.createElement(_dyzioIcons.TiktokIcon, { additionalStyles: { margin: "0 .75em 0 0" } }) : _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(channel), size: 'tiny' }),
                ' ',
                _lodash2.default.toLower(channel)
              );
            })
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          { scrolling: true, item: true, text: currentDiscussionName || 'influencer' },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            filter.discussion && _react2.default.createElement(
              _semanticUiReact.Dropdown.Item,
              {
                onClick: onFilterChange,
                value: 'discussion.reset'
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
              'reset'
            ),
            _lodash2.default.map(alphaSortedDiscussions, function (option) {
              return option.value && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  onClick: onFilterChange,
                  value: 'discussion.' + option.value
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                '\xA0',
                _lodash2.default.toLower(option.label)
              );
            })
          )
        )
      ),
      withDatePeriodFilter && _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        null,
        _react2.default.createElement(_DayPickerInput2.default, {
          component: function component(p) {
            return _react2.default.createElement(
              'div',
              { style: inputStyle, className: 'ui input' },
              _react2.default.createElement('input', p)
            );
          },
          onDayChange: function onDayChange(day) {
            return onDateFilterChange(day, 'start');
          },
          format: DATE_PICKER_DATE_FORMAT,
          dateFormat: DATE_PICKER_DATE_FORMAT,
          placeholder: 'Start date',
          formatDate: _moment3.formatDate,
          parseDate: _moment3.parseDate,
          value: datePeriodFilterValues.start
        }),
        _react2.default.createElement(_DayPickerInput2.default, {
          component: function component(p) {
            return _react2.default.createElement(
              'div',
              { style: inputStyle, className: 'ui input' },
              _react2.default.createElement('input', p)
            );
          },
          onDayChange: function onDayChange(day) {
            return onDateFilterChange(day, 'end');
          },
          format: DATE_PICKER_DATE_FORMAT,
          dateFormat: DATE_PICKER_DATE_FORMAT,
          placeholder: 'End date',
          formatDate: _moment3.formatDate,
          parseDate: _moment3.parseDate,
          value: datePeriodFilterValues.end
        })
      ),
      withDaysFilter && _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          { scrolling: true, item: true, text: perDaysOption ? perDaysOption.label : '30 days' },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            _lodash2.default.map(daysOptions, function (option) {
              return _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  key: option.id,
                  onClick: function onClick(e) {
                    return onPerDaysChanged(e, (0, _extends3.default)({}, option));
                  }
                },
                _lodash2.default.get(option, 'label', '-')
              );
            })
          )
        )
      ),
      withDaysFilter && _react2.default.createElement(
        _semanticUiReact.Menu.Item,
        null,
        _react2.default.createElement(_semanticUiReact.Label, {
          content: (perDaysOption ? perDaysOption.label : '30 days') + ' data',
          color: 'orange', basic: true
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        { position: 'right' },
        hasRightFilterOptions && _react2.default.createElement(
          _semanticUiReact.Dropdown,
          {
            scrolling: true,
            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus', style: pinkIconStyle }),
            item: true,
            basic: true,
            trigger: _react2.default.createElement(
              'span',
              { style: pinkBoldTextStyle },
              'Add a new asset'
            )
          },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            _lodash2.default.map(assetOptions, function (option) {
              return _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  onClick: option.onClick,
                  value: option.value
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
                option.label
              );
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { position: 'right', onClick: handleDownloadClick },
          _react2.default.createElement(
            _semanticUiReact.Label,
            { basic: true, size: 'large', color: 'pink' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
            _react2.default.createElement(
              _reactCsv.CSVLink,
              { data: basicData, filename: filename },
              'Download Report'
            )
          )
        ),
        shouldRenderShareableLinks && _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            _semanticUiReact.Dropdown,
            {
              scrolling: true,
              icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', style: greenIconStyle }),
              item: true,
              trigger: _react2.default.createElement(
                'span',
                { style: greenBoldTextStyle },
                'shareable reports'
              )
            },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              _lodash2.default.map(rightFilterOptions, function (option) {
                return _react2.default.createElement(
                  _semanticUiReact.Dropdown.Item,
                  {
                    value: option.value,
                    onClick: option.onClick
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
                  option.text
                );
              })
            )
          ),
          content: 'Get links to your shareable reports'
        })
      )
    ),
    appearsToBeEmpty && _react2.default.createElement(
      _semanticUiReact.Message,
      {
        icon: true,
        color: 'orange'
      },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar check outline' }),
      _react2.default.createElement(
        _semanticUiReact.Message.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message.Header,
          null,
          'This campaign has posts - you just cannot see them'
        ),
        'Choose ',
        _react2.default.createElement(
          'b',
          null,
          'All Days'
        ),
        ' in the selector above to see the posts/stories (your date range has filtered them out)'
      )
    ),
    isEmptyCampaign && !appearsToBeEmpty && !errored && _react2.default.createElement(
      _semanticUiReact.Message,
      {
        icon: true,
        info: _lodash2.default.eq(emptyCampaignMessageType, 'info'),
        warning: _lodash2.default.eq(emptyCampaignMessageType, 'warning')
      },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
      _react2.default.createElement(
        _semanticUiReact.Message.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message.Header,
          null,
          'Info'
        ),
        emptyCampaignText
      )
    ),
    isEmptyCampaign && !appearsToBeEmpty && errored && _react2.default.createElement(
      _semanticUiReact.Message,
      {
        icon: true,
        info: _lodash2.default.eq(emptyCampaignMessageType, 'info'),
        warning: _lodash2.default.eq(emptyCampaignMessageType, 'warning')
      },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
      _react2.default.createElement(
        _semanticUiReact.Message.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message.Header,
          null,
          'Info'
        ),
        'Could not load report. Please try setting a date range using the date filter'
      )
    ),
    !isEmptyCampaign && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _semanticUiReact.Card,
        { fluid: true, color: 'green' },
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            style: tableStyle,
            sortable: true,
            singleLine: true,
            celled: true,
            fixed: true,
            basic: 'very',
            size: 'small',
            textAlign: 'center'
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(_basicReportHeader2.default, {
              onOrderChanged: onOrderChanged,
              order: order,
              withDeleteButton: deleteCallback
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _lodash2.default.map(orderedPostsAndStories, function (post) {
              return _react2.default.createElement(_basicReportRow2.default, {
                deleteCallback: deleteCallback,
                viewMode: reportMode,
                post: post
              });
            }),
            showAggregates && _react2.default.createElement(_basicReportTotalsRow2.default, {
              totalReach: totalReach,
              totalImpressions: totalImpressions,
              influencerCount: influencerCount,
              assetCount: assetCount,
              totalEngagements: totalEngagements,
              totalViews: totalViews,
              totalShares: totalShares,
              totalComments: totalComments,
              totalLikes: totalLikes,
              withDeleteButton: deleteCallback
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { extra: true },
          _react2.default.createElement(
            'div',
            { className: 'ui right aligned' },
            'Report generated at ',
            _react2.default.createElement(
              'strong',
              null,
              (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
            ),
            '.'
          )
        )
      )
    )
  );
};

BasicReport.defaultProps = {
  withHeader: false,
  hasRightFilterOptions: true,
  emptyCampaignText: 'No posts included in this campaign',
  emptyCampaignMessageType: 'info',
  reportMode: 'external',
  withDaysFilter: false,
  withDatePeriodFilter: false,
  onDateFilterChange: _lodash2.default.noop,
  datePeriodFilterValues: {
    start: new Date(),
    end: new Date()
  },
  daysOptions: [],
  perDaysOption: null,
  deleteCallback: null,
  onPerDaysChanged: function onPerDaysChanged() {
    return _lodash2.default.noop;
  },
  hasMarketingCampaigns: false,
  ads: [],
  shouldRenderShareableLinks: true
};

exports.default = BasicReport;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report/index.js
 ** module id = 2585
 ** module chunks = 0
 **/